module.exports = __webpack_public_path__ + "img/joinpro1.8c213aac.jpg";